import { render, staticRenderFns } from "./packageDetalis.vue?vue&type=template&id=202ae764&scoped=true&"
import script from "./packageDetalis.vue?vue&type=script&lang=js&"
export * from "./packageDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ae764",
  null
  
)

export default component.exports